import React, { Component } from 'react';

import { Col, Row } from 'reactstrap';
import questionBankCardIcon from '../../../../public/img/question_bank/icon2.svg';
import ChapterCard from '../../../Components-2025/QuestionBank/ChapterCards';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import ComponentHeader from '../../../common/ComponentHeader';
import { messages } from '../../../common/messages';
import {
  chapterIdKey,
  chapterNameKay,
  chapterOrderKey,
  freeQuestionsCountKey,
  premiumQuestionsCountKey,
  questionTableKey,
  readingIdKey,
  totalReadingKey,
} from './ApiAttributesKeys';
import ApiServiceProvider from './ApiService';

import { showInformation } from '../../../common/toast';
import appRoutes from '../../config/AppRoutes';
import { nextAwareRoute } from '../../../common/cfa1NextRoutes';
import QuestionModeSetting from '../../../Components-2025/QuestionModeSetting';
import { EXAM_NAMES } from '../../../common/constant';

/* eslint-disable*/

export class QuestionBank extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      chapterId: '',
      questionId: '',
      isLoading: true,
      isLastAttemptButtonDisable: false,
      chapterData: [],
      selectedExamSubscriptionDetails: {},
    };
  }
  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
  componentDidMount = async () => {
    this.getChapterWiseCount();
  };
  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================

  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================

  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
  getChapterWiseCount = async () => {
    const result = await ApiServiceProvider['getChaptersWithPremiumAndFreeCount']();
    if (result.success) {
      this.setState({
        isLoading: false,
        chapterData: result.data ? result.data : [], //* we will uncomment when api is ready
      });
    }
    this.setState({ isLoading: false });
  };

  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================

  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
  onHandleLastAttemptedQuestion = async () => {
    this.setState({ isLastAttemptButtonDisable: true });
    const result = await ApiServiceProvider['fetchLastAnsweredQuestion']();
    this.setState({ isLastAttemptButtonDisable: false });

    //* FIRST OF ALL CHECK THE REDIRECTION
    if (result.success) {
      const { data } = result;
      const { router } = this.context;
      if (data) {
        router.push({
          pathname: nextAwareRoute(appRoutes.CFA1_2025_QUESTION_VIEW).replace(
            ':readingId',
            data[questionTableKey][readingIdKey],
          ).replace(':questionId', data[questionTableKey].id),
        });
      }else{
        showInformation(messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
      }
    } else {
      showInformation(messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
    }
  };
  //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================
  render() {
    const { state, context } = this;
    const { isLoading, chapterData, isLastAttemptButtonDisable } = state;
    const { router } = context;

    return (
      <div className='animated fadeIn'>
        {/*//*================================================={{ PART I AND II START HERE }}================================================  */}
        <ComponentHeader title={messages.QUESTION_BANK}>
          <QuestionModeSetting examNameKey={EXAM_NAMES.CFA_1} />
          <button
            className='btn btn-primary pointer_class'
            onClick={() => this.onHandleLastAttemptedQuestion()}
            disabled={isLastAttemptButtonDisable}
          >
            {isLastAttemptButtonDisable && <i className='fa fa-spinner fa-spin mr-1' />}
            {messages.GO_TO_MY_LAST_QUESTION_ANSWERED}
          </button>
        </ComponentHeader>
        <LoaderWrapper isLoading={isLoading}>
          <Row>
            <Col className='seperator-block-wrap'>
              <div className='card'>
                <div className='card-block'>
                  <Row>
                    {chapterData.length &&
                      chapterData.map(item => {
                        return (
                          <ChapterCard
                            onClick={() =>
                              router.push({
                                pathname: nextAwareRoute(appRoutes.CFA1_2025_QUESTION_BANK_READING_LIST).replace(
                                  ':chapterId',
                                  item[chapterIdKey],
                                ),
                                state: { chapterData },
                              })
                            }
                            key={item[chapterIdKey]}
                            headerImage={questionBankCardIcon}
                            headerImageWidth={55}
                            chapterNumber={item[chapterOrderKey]}
                            chapterName={item[chapterNameKay]}
                            totalReadings={item[totalReadingKey]}
                            freeQuestionsCount={item[freeQuestionsCountKey]}
                            premiumQuestionsCount={item[premiumQuestionsCountKey]}
                            {...this.props}
                          />
                        );
                      })}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </LoaderWrapper>
        {/*//*================================================={{ PART I AND II ENDED HERE }}================================================  */}
      </div>
    );
  }
}

export default QuestionBank;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/index.jsx